export const FETCH_PAYMENT_CONFIGURATION_STARTED = 'FETCH_PAYMENT_CONFIGURATION_STARTED';
export const FETCH_PAYMENT_CONFIGURATION_SUCCEEDED = 'FETCH_PAYMENT_CONFIGURATION_SUCCEEDED';
export const FETCH_PAYMENT_CONFIGURATION_FAILED = 'FETCH_PAYMENT_CONFIGURATION_FAILED';
